// 🔴 P1 (démo Laurent) — LA fonction partagée de comparaison d'adresses de SITES (anti-doublon). Visite Mario (renovation/entreeVisite) ET fiche dossier
// (metier/artisan/DossierArtisanView) l'utilisent : ⛔ aucune copie. Comparaison seulement (casse, accents, ponctuation, espaces) ; ⛔ pas pour afficher.
const plat = (t) => String(t || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export function cleAdresse(a) {
  return plat([a?.adresse, a?.code_postal, a?.ville].filter(Boolean).join(" ")).replace(/[^a-z0-9]+/g, " ").trim();
}

/** Le site ÉQUIVALENT déjà connu (mêmes adresse + code postal + ville, une fois normalisées), ou undefined. `sites` = ceux du MÊME client (le serveur ne rend que le tenant de la session). */
export function trouverSiteEquivalent(sites, adresse) {
  const cle = cleAdresse(adresse);
  return cle ? (sites || []).find((s) => cleAdresse(s) === cle) : undefined;
}
